import { useSession } from 'next-auth/react';
import { PropsWithChildren } from 'react';
import { RootStoreProvider } from '../../store/provider/RootStoreProvider';
import { getSessionStorageItem, StorageHelperKeys } from '../../utils/storageHelpers';

// session is always available after this component till the most nested children
export default function AuthenticatedPage({ children }: PropsWithChildren) {
    const { data: session } = useSession();
    const openTabKeys = getSessionStorageItem(StorageHelperKeys.OPEN_TAB_KEYS);

    return <RootStoreProvider hydrationData={{ session, openTabKeys }}>{children}</RootStoreProvider>;
}
